import { Box, Flex, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const Container = styled(Box)`
  background: #ffffff;
  width: auto;
`;

export const SectionContainer = styled(Box)``;

export const SectionHeading = styled(Text)`
  color: #000;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 20px;
`;

export const ItemsContainer = styled(Flex)`
  flex-direction: column;
  gap: 1.25rem;
`;

export const Item = styled(Flex)`
  flex-direction: row;
  gap: 1rem;
  align-items: flex-start;
`;

export const ItemIcon = styled(Box)`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 45px;
  height: 45px;
`;

export const NotCoveredIcon = styled(Box)`
  position: relative;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #ff4444;
    z-index: 1;
  }

  &::after {
    content: "✕";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    font-weight: bold;
    z-index: 3;
  }

  & > div {
    position: relative;
    z-index: 2;
    filter: grayscale(100%) brightness(0.7);
  }
`;

export const ItemContent = styled(Flex)`
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
`;

export const ItemName = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const ItemDescription = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #5b5675;
`;

export const LearnMoreLink = styled.button`
  background: none;
  border: none;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;

  &:hover {
    color: #0056cc;
  }
`;

export const LearnMoreText = styled(Text)`
  color: var(--Neutral-N400, #5b5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  transform: translateZ(0);
`;
